import styled from "styled-components";
import { bettoProfileCssVariables } from "../../shared/bettoProfileTheme";
import { BTTO_PROFILE_COLORS } from "../../shared/elements";

export const BettoContentWrapper = styled.div.attrs({
	className: "bt-betto-profile-content",
})`
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;
	${bettoProfileCssVariables}

	&.bt-betto-profile-content {
		.profile-page-wrapper,
		.profile-page-content {
			background: transparent !important;
			padding: 0 !important;
		}

		[class*="ContentWrapper"]:not([class*="DatePicker"]) {
			background: transparent !important;
			border: none !important;
			border-radius: 0 !important;
			padding: 0 !important;
		}

		[class*="BonusesCard"] {
			overflow: hidden;
		}

		[class*="BonusesContent"] {
			background: transparent !important;
			border: none !important;
			padding: 0 !important;
		}

		[class*="BonusesHeaderTabs"] {
			gap: 8px;
			padding-bottom: 4px;
		}

		[class*="BonusesHeaderTab"] {
			height: 36px;
			padding: 0 14px;
			border-radius: 8px;
			border: 1px solid ${BTTO_PROFILE_COLORS.border};
			font-size: 12px;
			font-weight: 600;
			transition:
				background 0.2s ease,
				border-color 0.2s ease,
				color 0.2s ease;
		}

		[class*="BonusItemWrapper"],
		[class*="CompletedBonusItemWrapper"] {
			background: ${BTTO_PROFILE_COLORS.surfaceRaised} !important;
			border: 1px solid ${BTTO_PROFILE_COLORS.border};
			border-radius: 12px;
			overflow: hidden;
			margin-bottom: 12px !important;
		}

		[class*="ItemHeader"] {
			background: rgba(3, 98, 212, 0.12) !important;
			color: ${BTTO_PROFILE_COLORS.text} !important;
			border-radius: 0 !important;
		}

		[class*="ItemContent"],
		[class*="ContentInfo"] {
			background: transparent !important;
			color: ${BTTO_PROFILE_COLORS.textMuted};
		}

		[class*="InfoTitle"],
		[class*="HeaderTitle"],
		[class*="Info"] {
			color: ${BTTO_PROFILE_COLORS.text} !important;
		}

		[class*="BonusItemWrapper"] [class*="DetailsButton"],
		[class*="BonusItemWrapper"] [class*="ContentButton"],
		[class*="CompletedBonusItemWrapper"] [class*="DetailsButton"],
		[class*="CompletedBonusItemWrapper"] [class*="ContentButton"] {
			border-radius: 8px !important;
			background: ${BTTO_PROFILE_COLORS.primary} !important;
			color: ${BTTO_PROFILE_COLORS.primaryText} !important;
		}

		[class*="EmptyStateRoot"] {
			padding: 32px 16px;
			min-height: 240px;
		}

		[class*="BettoInboxContentCard"] [class*="EmptyStateRoot"] {
			padding: 24px 8px;
			min-height: 200px;
		}

		[class*="ItemWrapper"] {
			flex-wrap: wrap;
			gap: 12px;
			align-items: stretch;
		}

		.history-menu-wrapper {
			margin-top: -1px;
		}

		.date-picker-wrapper {
			flex: 1;
			min-width: 0;
		}

		[class*="Amount"] strong,
		[class*="Amount"] span {
			color: ${BTTO_PROFILE_COLORS.text};
		}

		[class*="CashbackContentStyled"] {
			overflow: hidden;
		}

		[class*="CashbackItemWrapperStyled"] {
			background: ${BTTO_PROFILE_COLORS.surfaceRaised} !important;
			border: 1px solid ${BTTO_PROFILE_COLORS.border};
			border-radius: 12px;
		}

		[class*="CashbackItemHeaderStyled"] {
			background: rgba(3, 98, 212, 0.12) !important;
			color: ${BTTO_PROFILE_COLORS.text} !important;
		}

		[class*="CashbackItemAmountValueStyled"] {
			color: ${BTTO_PROFILE_COLORS.text} !important;
		}

		[class*="CashbackItemAmountLabelStyled"],
		[class*="CashbackItemStatusMessageStyled"],
		[class*="CashbackStateDescriptionStyled"] {
			color: ${BTTO_PROFILE_COLORS.textMuted} !important;
		}

		[class*="CashbackStateTitleStyled"] {
			color: ${BTTO_PROFILE_COLORS.text} !important;
		}

		[class*="CashbackItemClaimButtonStyled"],
		[class*="CashbackRetryButtonStyled"] {
			border-radius: 8px !important;
			background: ${BTTO_PROFILE_COLORS.primary} !important;
			color: ${BTTO_PROFILE_COLORS.primaryText} !important;
			border: none;
		}

		[class*="CashbackRefreshButtonStyled"] {
			border-radius: 8px !important;
			border: 1px solid ${BTTO_PROFILE_COLORS.border} !important;
			color: ${BTTO_PROFILE_COLORS.textMuted} !important;
			background: transparent !important;

			&:hover {
				border-color: ${BTTO_PROFILE_COLORS.borderActive} !important;
				color: ${BTTO_PROFILE_COLORS.text} !important;
			}
		}
	}
`;
